import { ActionTree, GetterTree, ModuleTree, MutationTree } from "vuex";
import axios from 'axios';
import { NOT_CALLED, API_CALL_ERROR, API_CALL_SUCCESSFUL, API_CALL_PENDING, ApiState } from "@/common/store/util/ApiStates";
import { User } from "@/common/types/User";
import { i18n } from '@/plugins/i18n';
import { extractBrokerOfUser } from "@/common/types/BrokerUser";
import router from "@/common/router";

export type AuthState = {
  token: string,
  status: ApiState,
  loggedInUser: User,
  hasLoadedOnce: boolean,
  broker: string | null
};

type RootState = {};

const state: AuthState = {
  token: localStorage.getItem('user-token') || '',
  status: '',
  loggedInUser: localStorage.getItem('user') ? JSON.parse(<string>localStorage.getItem('user')) : { id: '', email: '', firstName: '', lastName: '', brokerLinkStatus: '', address: 0 },
  hasLoadedOnce: false,
  broker: localStorage.getItem('user-broker') || ''
};

const getters: GetterTree<AuthState, RootState> = {
  isAuthenticated: (state: AuthState) => {
    axios.defaults.headers.common['ApiLevel'] = '1';
    return !!state.token;
  },
  LOGGEDINUSER: state => state.loggedInUser,
  IS_SUPERADMIN: state => state.loggedInUser.email === 'superadmin@onelogic.de',
  CHANGE_BROKER_ALLOWED: state => state.loggedInUser.email === 'superadmin@onelogic.de' || state.loggedInUser.email === '48bndevkonto@gmail.com',
  BROKER: state => state.broker
};

const actions: ActionTree<AuthState, RootState> = {
  ['AUTH_REQUEST']: async ({ commit, dispatch }, user) => {
    try {
      commit('AUTH_REQUEST');
      user.mandant = 'FKD';
      user.publisher = 'FKD';

      const resp: any = await axios.post(process.env.VUE_APP_API_URL + '/v1/users/login', null, { params: user });
      const token = resp.headers.authorization;
      localStorage.setItem('user-token', token);
      axios.defaults.headers.common['Authorization'] = token;
      commit('AUTH_SUCCESS', resp);
      return resp;

    } catch (error) {
      if (error.response.status === 401) {
        commit('ERROR', error.response.data.errors[0].message, { root: true });
        commit('AUTH_ERROR', error);
      }
      throw error;
    }
  },
  ['AUTH_LOGOUT']: async ({ commit }) => {
    localStorage.removeItem('user-token');
    localStorage.removeItem('user');
    delete axios.defaults.headers.common['Authorization'];
    commit('AUTH_LOGOUT');
  }
};

const mutations: MutationTree<AuthState> = {
  ['AUTH_REQUEST']: (state) => {
    state.status = API_CALL_PENDING;
  },
  ['AUTH_SUCCESS']: (state, resp) => {
    state.status = API_CALL_SUCCESSFUL;
    state.token = resp.headers.authorization;
    state.loggedInUser = resp.data;

    state.broker = extractBrokerOfUser(state.loggedInUser);
    localStorage.setItem('user-broker', <string>state.broker);

    i18n.locale = <string>state.loggedInUser.language;

    localStorage.setItem('user', JSON.stringify(state.loggedInUser));

    state.hasLoadedOnce = true;
  },
  ['AUTH_ERROR']: (state, error) => {
    state.status = API_CALL_ERROR;
    state.hasLoadedOnce = true;
  },
  ['AUTH_LOGOUT']: (state) => {
    state.token = NOT_CALLED;
  },
  ['CHANGE_LANGUAGE']: (state, language) => {
    state.loggedInUser.language = language;
    i18n.locale = language;
  },
  ['UPDATE_BROKER']: (state, broker) => {
    state.broker = broker;
    localStorage.setItem('user-broker', <string>state.broker);
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
} as ModuleTree<AuthState>;

export const LOGGEDINUSER = 'LOGGEDINUSER';
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';